/**
 * Register DiscountCode Alpine.js component
 * Handles registration when Alpine is available
 */
import discountCode from './discount-code.js';

if (typeof window !== 'undefined') {
  // Wait for Alpine to be available (from global.bundle.js)
  const registerDiscountCode = () => {
    if (window.Alpine || window.Alpine2) {
      const Alpine = window.Alpine || window.Alpine2;
      if (!Alpine.data('DiscountCode')) {
        Alpine.data('DiscountCode', discountCode);
      }
    } else {
      // Retry if Alpine isn't loaded yet
      setTimeout(registerDiscountCode, 100);
    }
  };

  // Start registration when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerDiscountCode);
  } else {
    registerDiscountCode();
  }

  // Also listen for Alpine ready event if it exists
  document.addEventListener('switch:alpine:started', registerDiscountCode);
}

